import React from "react";
import { BlockSquare } from "../common/StyledComponents";
import { IconDraggable, IconEdit } from "../Layout/Icons";
import ImumProductTagAction from "./ImumProductTagAction";
import moment from "moment";

const ImumProductTag = ({
  id,
  color,
  title,
  valid_from,
  valid_to,
  expiration_action,
  action,
  setAction,
  onEdit,
  globalTag,
  setGlobalTag,
  context,
}) => {
  if (action.id == id) {
    return (
      <div>
        <ImumProductTagAction
          action={action.values}
          setAction={setAction}
          globalTag={globalTag}
          setGlobalTag={setGlobalTag}
          context={context}
        />
      </div>
    );
  }
  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between bg-white p-2 mb-1"
        style={{
          border: "1px solid #E9E9E9",
          borderRadius: 2,
        }}
      >
        <div className="d-flex align-items-center">
          <div className="mr-2">
            <IconDraggable />
          </div>
          <BlockSquare color={color} />
          <div className="ml-1 text-sm text-black">{title}</div>
        </div>
        <IconEdit
          className="text-xl cursor-pointer"
          color="#929292"
          onClick={() => {
            onEdit({
              id,
              values: {
                color,
                title,
                valid_from: valid_from ? moment(valid_from) : null,
                valid_to: valid_to ? moment(valid_to) : null,
                expiration_action: expiration_action || "keep_rules",
              },
            });
          }}
        />
      </div>
    </>
  );
};

export default ImumProductTag;
